module.exports="precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 frag_col;\n\nvoid main() {\n    gl_FragColor = frag_col;\n}";